import { defineNuxtRouteMiddleware } from '#imports'
import { asRouteMiddleware, requireAuthForCheckout } from '@utils/route-guards'

export default defineNuxtRouteMiddleware(asRouteMiddleware(requireAuthForCheckout))
